/**
 * The API's message from a failed request, for inline error alerts: a plain
 * `error` string, else the first `errors[].msg`, else `fallback`.
 *
 * @param error - The query or mutation error (an Amplify/axios error)
 * @param fallback - Shown when the API sent no message
 */
export const getErrorMessage = (params: {
  error: unknown;
  fallback: string;
}) => {
  const data = (
    params.error as {
      response?: {
        data?: { error?: unknown; errors?: { msg?: string | null }[] };
      };
    } | null
  )?.response?.data;

  if (typeof data?.error === 'string' && data.error) {
    return data.error;
  }
  return data?.errors?.find((item) => item.msg)?.msg || params.fallback;
};
